export const article = {
  authorPopover:
    "Written by <AuthorLink>{{name}}</AuthorLink>{{descriptionPopover}}",
  by: "By",
  conversion: {
    cta: "Join Conceive",
    description:
      "Get started with a Conceive membership today and get instant access to 24/7 text, phone, and video call support from our team of leading fertility nurses and peer coaches.",
    heading: "Get fertility support",
  },
  medicalReviewer:
    "<ReviewStyle>Medically Reviewed</ReviewStyle> by <MedicalReviewer>{{reviewer}}</MedicalReviewer>",
  medicallyReviewedByPopover: "Medically reviewed by",
  medicallyReviewed: "Medically reviewed",
  published: "Published",
  updated: "Updated",
  upsell: {
    cta: " Join Conceive",
    heading:
      "Get access to this article—along with 24/7 text, phone, and video chat from expert fertility nurses and peer coaches with a Conceive membership.",
  },
};
